
import { defineComponent } from 'vue'
import IconControl from './IconControl.vue'

export default defineComponent({
  components: {
    IconControl
  },
  props: {
    icons: {
      type: Array,
      default: () => []
    }
  }
})
